/* eslint-disable */
import PropTypes from 'prop-types';
import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import Footer from '../../components/footer/Footer';
import Navbar from '../../components/navbar/Navbar';
import MobileBottomNav from '../../components/navbar/MobileBottomNav';

import AboutPage from '../About';
import HomePage from '../Home';
import MarketPlacePage from '../market/MarketPlace';
import MyCartPage from '../market/MyCart';
import MyPaymentPage from '../market/MyPayment';
import ProductViewPage from '../market/ProductView';
import ShopSellerPage from '../market/ShopSeller';
import MyShopPage from '../myshop/MyShop';
import ProfilePage from './Profile';
import JobSearch from '../jobs/JobSearch';
import JobDetail from '../jobs/JobDetail';
import EmployerJobDashboard from '../jobs/EmployerJobDashboard';

const MemberLandingPage = ({
  app_hostname,
  permitdata,
  systemdata_productcategorylist,
  systemdata_shoporderlist,
  systemdata_shopitemlist,
  shopitem_total,
  callback_load_shopitems,
  buyer_category,
  productCatalog,
  messages_chat_buffer,
  isConnectionOpen_notify,
  notify_ws,
  mycartlen,
  myorderlen,
  messages_chat_unread,
  notify_data,
  callback_mycart,
  callback_maindatachange,
  callback_signout,
  callback_notify_ack,
  callback_notify_animation,
}) => {
  const isShopLoggedIn = permitdata && permitdata.role !== 'guest' && permitdata.token && permitdata.token !== '-';
  const isJobOnlyLoggedIn = sessionStorage.getItem('meya-job-loggedin') === 'true' && !isShopLoggedIn;

  return (
    <div className='page-container'>
      <div className='page-wrap'>
        <Navbar
          islogin={false}
          permitdata={permitdata}
          systemdata_productcategorylist={systemdata_productcategorylist}
          buyer_category={buyer_category}
          productCatalog={productCatalog}
          mycartlen={mycartlen}
          myorderlen={myorderlen}
          messages_chat_unread={messages_chat_unread}
          app_hostname={app_hostname}
          callback_signout={callback_signout}
        />

        <Routes>
          <Route
            path='/home'
            element={
              <HomePage
                app_hostname={app_hostname}
                permitdata={permitdata}
                systemdata_shoporderlist={systemdata_shoporderlist}
                systemdata_shopitemlist={systemdata_shopitemlist}
                callback_datachanged={(mode, data) => {
                  callback_maindatachange(mode, data);
                }}
              />
            }
          />
          <Route
            path='/marketplace'
            element={
              <MarketPlacePage
                app_hostname={app_hostname}
                permitdata={permitdata}
                buyer_category={buyer_category}
                systemdata_productcategorylist={systemdata_productcategorylist}
              />
            }
          />
          <Route
            path='/marketplace/shopseller'
            element={
              <ShopSellerPage
                app_hostname={app_hostname}
                permitdata={permitdata}
                buyer_category={buyer_category}
                systemdata_productcategorylist={systemdata_productcategorylist}
              />
            }
          />
          <Route
            path='/marketplace/productview'
            element={
              isJobOnlyLoggedIn ? (
                <Navigate
                  to='/marketplace?category=สินค้าโปรโมชั่น&&transaction=FNYG18ZWHu'
                  replace
                />
              ) : (
                <ProductViewPage
                  app_hostname={app_hostname}
                  permitdata={permitdata}
                  callback_mycart={(mode, data) => {
                    callback_mycart(mode, data);
                  }}
                />
              )
            }
          />
          <Route
            path='/marketplace/mycart'
            element={
              isJobOnlyLoggedIn ? (
                <Navigate
                  to='/marketplace?category=สินค้าโปรโมชั่น&&transaction=FNYG18ZWHu'
                  replace
                />
              ) : (
                <MyCartPage
                  app_hostname={app_hostname}
                  permitdata={permitdata}
                  mycartlen={mycartlen}
                  callback_mycart={(mode, data) => {
                    callback_mycart(mode, data);
                  }}
                />
              )
            }
          />
          <Route
            path='/marketplace/mypayment'
            element={
              isJobOnlyLoggedIn ? (
                <Navigate
                  to='/marketplace?category=สินค้าโปรโมชั่น&&transaction=FNYG18ZWHu'
                  replace
                />
              ) : (
                <MyPaymentPage
                  app_hostname={app_hostname}
                  permitdata={permitdata}
                  callback_mycart={(mode, data) => {
                    callback_mycart(mode, data);
                  }}
                  callback_maindatachange={(mode, data) => {
                    callback_maindatachange(mode, data);
                  }}
                />
              )
            }
          />
          <Route
            path='/myshop/*'
            element={
              isJobOnlyLoggedIn ? (
                <Navigate
                  to='/marketplace?category=สินค้าโปรโมชั่น&&transaction=FNYG18ZWHu'
                  replace
                />
              ) : (
                <MyShopPage
                  app_hostname={app_hostname}
                  permitdata={permitdata}
                  systemdata_productcategorylist={systemdata_productcategorylist}
                  systemdata_shoporderlist={systemdata_shoporderlist}
                  systemdata_shopitemlist={systemdata_shopitemlist}
                  shopitem_total={shopitem_total}
                  callback_load_shopitems={callback_load_shopitems}
                  buyer_category={buyer_category}
                  productCatalog={productCatalog}
                  messages_chat_buffer={messages_chat_buffer}
                  isConnectionOpen_notify={isConnectionOpen_notify}
                  notify_ws={notify_ws}
                  callback_mycart={(mode, data) => {
                    callback_mycart(mode, data);
                  }}
                  callback_maindatachange={(mode, data) => {
                    callback_maindatachange(mode, data);
                  }}
                />
              )
            }
          />
          <Route
            path='/me'
            element={<ProfilePage permitdata={permitdata} callback_signout={callback_signout} />}
          />
          <Route
            path='/profile'
            element={<ProfilePage permitdata={permitdata} callback_signout={callback_signout} />}
          />
          <Route
            path='/jobs'
            element={
              <JobSearch
                permitdata={permitdata}
                app_hostname={app_hostname}
                isUserLoggedIn={true}
                regName={permitdata?.shop_name || permitdata?.user_name || ''}
              />
            }
          />
          <Route
            path='/jobs/detail/:id'
            element={
              <JobDetail
                permitdata={permitdata}
                app_hostname={app_hostname}
                isUserLoggedIn={true}
                regName={permitdata?.shop_name || permitdata?.user_name || ''}
                regEmail={permitdata?.shop_email || ''}
              />
            }
          />
          <Route
            path='/jobs/employer'
            element={
              <EmployerJobDashboard permitdata={permitdata} app_hostname={app_hostname} />
            }
          />
          <Route path='/about' element={<AboutPage permitdata={permitdata} />} />
        </Routes>
        <div className={'notification ' + (notify_data.length > 0 ? '' : 'd-none')}>
          {notify_data.map((notify, index) =>
            index < 10 ? (
              <div
                className='my-3 notification__box flyInRight'
                id={notify.id}
                key={notify.id}
                onAnimationEnd={() => callback_notify_animation(notify.id)}
              >
                <div className='notification__content'>
                  <div className={'notification__icon ' + notify.icon}>
                    {notify.icon === 'error' ? (
                      <i className='fe-alert-triangle'></i>
                    ) : notify.icon === 'warning' ? (
                      <i className='fe-bell'></i>
                    ) : notify.icon === 'success' ? (
                      <i className='fe-check-circle'></i>
                    ) : (
                      <i className='fe-help-circle'></i>
                    )}
                  </div>
                  <div className='notification__text'>
                    <div className='notification__text-title'>{notify.title}</div>
                    <div className='notification__text-subtitle'>{notify.subtitle}</div>
                  </div>
                </div>
                <div className='notification__btns'>
                  <button
                    className='notification__btn'
                    type='button'
                    data-dismiss='ZjYyO3zBVV7SUDG8cLBt5NyUllmyuT'
                    onClick={() => {
                      callback_notify_ack(notify.id);
                    }}
                  >
                    <span className='notification__btn-text'>รับทราบ</span>
                  </button>
                </div>
              </div>
            ) : null,
          )}
        </div>
      </div>
      <div className='d-none d-xl-block'>
        <Footer islogin={false} permitdata={permitdata}></Footer>
      </div>
      <MobileBottomNav
        permitdata={permitdata}
        app_hostname={app_hostname}
        mycartlen={mycartlen}
        myorderlen={myorderlen}
        messages_chat_unread={messages_chat_unread}
        productCatalog={productCatalog}
        islogin={false}
      />
    </div>
  );
};

MemberLandingPage.propTypes = {
  app_hostname: PropTypes.string.isRequired,
  permitdata: PropTypes.object.isRequired,
  systemdata_productcategorylist: PropTypes.array.isRequired,
  systemdata_shoporderlist: PropTypes.array.isRequired,
  systemdata_shopitemlist: PropTypes.array.isRequired,
  shopitem_total: PropTypes.number.isRequired,
  callback_load_shopitems: PropTypes.func.isRequired,
  buyer_category: PropTypes.array.isRequired,
  productCatalog: PropTypes.object.isRequired,
  messages_chat_buffer: PropTypes.array.isRequired,
  isConnectionOpen_notify: PropTypes.bool.isRequired,
  notify_ws: PropTypes.object.isRequired,
  mycartlen: PropTypes.number.isRequired,
  myorderlen: PropTypes.number.isRequired,
  messages_chat_unread: PropTypes.number.isRequired,
  notify_data: PropTypes.array.isRequired,
  callback_mycart: PropTypes.func.isRequired,
  callback_maindatachange: PropTypes.func.isRequired,
  callback_signout: PropTypes.func.isRequired,
  callback_notify_ack: PropTypes.func.isRequired,
  callback_notify_animation: PropTypes.func.isRequired,
};

export default MemberLandingPage;
